import { Control, Field, Input } from "@allxsmith/bestax-bulma";
import React from "react";
import useInlineEditButton from "./useInlineEditButton";

function useEditableTableDateCell({
  propName,
  value,
  onChange,
  onSave,
  editable,
  setEditable,
  disabled,
  inlineEdit,
  monthOnly,
  tdClass
}) {
  return (
    <td onClick={e => e.stopPropagation()} className={tdClass}>
      <Field className="has-addons">
        <Control className={inlineEdit ? "date-cell" : ""}>
          <Input
            className={`small-row-black ${monthOnly ? 'extra-max-width' : ''}`}
            onChange={onChange}
            type={monthOnly ? 'month': 'date'}
            name={propName}
            value={value || ""}
            disabled={!editable}
          />
        </Control>
        {useInlineEditButton({show: inlineEdit, onSave, setEditable, editable, disabled})}
      </Field>
    </td>
  );
}

export default useEditableTableDateCell;
